// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");
let PropertyAddressValidationCallout = require("./PropertyAddressValidationCallout.bs.js");

function PropertyMlsValidationStatusComponents$AlreadyOnMlsCannotBeBroadcast(props) {
  return JsxRuntime.jsx(PropertyAddressValidationCallout.make, {
    heading: "This property is already on the MLS",
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("p", {
        children: "This property is already on the MLS and therefore cannot be broadcast on TAN. Please contact us if you have any questions."
      }),
      className: "leading-normal"
    }),
    icon: "Warning"
  });
}

let AlreadyOnMlsCannotBeBroadcast = {
  make: PropertyMlsValidationStatusComponents$AlreadyOnMlsCannotBeBroadcast
};

exports.AlreadyOnMlsCannotBeBroadcast = AlreadyOnMlsCannotBeBroadcast;
/* react/jsx-runtime Not a pure module */
